export enum Name {
  Headline = "headline",
  Paragraph = "paragraph",
  PodcastWrapperSource = "podcastWrapperSource",
  Uri = "uri",
  Kicker = "kicker",
  QuoteLabel = "quoteLabel",
  Quote = "quote",
  Quotee = "quotee",
  QuoteCredit = "quoteCredit",
  QuoteRule = "quoteRule",
  CropSelection = "cropSelection",
  Caption = "caption",
  Credit = "credit",
  Byline = "byline",
  TitleColor = "titleColor",
  Alignment = "alignment",
  DisplayCaption = "displayCaption",
  DisplayFullWidth = "displayFullWidth",
  ConvertToParallax = "convertToParallax",
  DataWrapperSrc = "dataWrapperSource",
  DynamicIframe = "dynamicIframe",
  Title = "title",
  YoutubeId = "youtubeId",
  AutoPlay = "autoplay",
  ClosedCaption = "closedcaption",
  AllowFullScreen = "allowfullscreen",
  TableEditor = "tableeditor",
  RowHeader = "rowheader",
  ColumnHeader = "columnheader",
  Description = "description",
  BrightcoveId = "brightcoveId",
  BrightcovePreview = "brightcovePreview",
  Display = "display",
  EmbedUrl = "embedUrl",
  Standfirst = "standfirst",
}

export enum Type {
  Headline = "headline",
  Paragraph = "paragraph",
  PodcastWrapper = "podcast_wrapper",
  Kicker = "kicker",
  Standfirst = "standfirst",
  Image = "image",
  Embed = "embed",
  BrightcoveVideo = "brightcove_video",
  SubHead = "subhead",
  Headings = "headings",
  ExternalLink = "external_link",
  Graphic = "graphic",
  Relation = "relation",
  GroupedRelation = "grouped_relation",
  Note = "note",
  HTMLAnchor = "htmlAnchor",
  CSSClass = "cssClass",
  DataAttributes = "dataAttribute",
}

export enum ArticleDisplayType {
  MainNewsDefault = "mainNewsDefault",
  VerticalsNewsDefault = "verticalsNewsDefault",
  Lifestyle = "lifestyle",
  Infographics = "infographics",
  Compact = "compact",
}

export enum HeroVariant {
  Main = "main",
  Secondary = "secondary",
}

export enum TagsVariant {
  Inside,
  Outside,
}

export enum AdvertisementTypeEnum {
  IMU1 = "imu1",
  IMU2 = "imu2",
  IMU3 = "imu3",
  LB1 = "lb1",
  LB2 = "lb2",
  CATFISH = "catfish",
  MIDARTICLE = "midarticlespecial",
  PRESTITIAL = "prestitial",
  TOPOVERLAY = "topoverlay",
}

/**
 * A parameter used for making requests to OpenSearch
 */
export enum OS_CATEGORY_PARAM {
  Title = "title",
  Author = "author",
  Tags = "tags",
  Sections = "sections",
  ArticleIdForPrerender = "queryArticleByIdForPrerender",
  SectionUniqueNameForPrerender = "querySectionsByUniqueNameForPrerender",
}

export enum CaasSchema {
  Cue = "cue-article",
}
export enum CaasEvent {
  Create = "create",
  Delete = "delete",
}
export enum CueEventState {
  Published = "published",
  Unpublished = "unpublished",
}

export enum AccessFlag {
  Premium = "2",
  Free = "0",
}
